export const dietTypes = Object.freeze({
  CELIACA: 'celiaca',
  VEGETARIANA: 'vegetariana',
  VEGANA: 'vegana',
  ALTRO: 'altro',
})
